interface InevitradeLogoProps {
  height?: number;
  className?: string;
}

export function InevitradeLogo({ height = 16, className = '' }: InevitradeLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 218.82 42.64"
      height={height}
      className={className}
      fill="currentColor"
    >
      {/* IT mark */}
      <polygon points="14.01 11.97 16.92 0 7.47 0 0 30.67 9.46 30.67 12.06 19.97 18.89 19.97 13.37 42.64 22.83 42.64 28.35 19.97 36.57 19.97 38.52 11.97 14.01 11.97" />
      {/* I */}
      <path d="M50.11,26.22V8.09h4.25v18.13h-4.25Z" />
      {/* N */}
      <path d="M56.78,26.22V8.09h3.91l8.5,9.45c.16.14.35.34.57.61.22.26.44.53.67.79.23.26.41.49.55.69l.19-.03c-.02-.32-.03-.68-.04-1.08,0-.4-.01-.76-.01-1.06v-9.37h4.04v18.13h-3.85l-8.55-9.56c-.32-.33-.65-.7-.99-1.11-.34-.41-.61-.72-.81-.95h-.16c0,.25,0,.57.01.96,0,.4.01.82.01,1.28v9.37h-4.04Z" />
      {/* E */}
      <path d="M77.23,26.22V8.09h16.52v3.43h-12.27v3.77h10.85v3.38h-10.85v4.12h12.46v3.43h-16.71Z" />
      {/* V */}
      <path d="M102.2,26.22l-7.63-18.13h4.67l4.17,10.64c.12.28.26.62.41,1.02.15.4.29.78.44,1.15.14.37.25.7.34.98h.18c.09-.26.2-.58.34-.94.14-.36.29-.73.44-1.12.15-.39.29-.75.41-1.08l4.17-10.64h4.46l-7.63,18.13h-4.78Z" />
      {/* I */}
      <path d="M115.69,26.22V8.09h4.25v18.13h-4.25Z" />
      {/* T */}
      <path d="M128.16,26.22v-14.54h-6.89v-3.59h18.05v3.59h-6.89v14.54h-4.28Z" />
      {/* R */}
      <path d="M140.73,26.22V8.09h12.3c1.32,0,2.41.25,3.27.75.86.5,1.5,1.18,1.93,2.05.42.86.63,1.83.63,2.9,0,1.14-.27,2.18-.8,3.1-.54.92-1.34,1.64-2.42,2.15l3.75,7.18h-4.73l-3.22-6.44h-6.47v6.44h-4.25ZM144.98,16.43h7.1c.77,0,1.38-.23,1.81-.7.43-.47.65-1.09.65-1.86,0-.49-.1-.92-.29-1.28-.19-.36-.47-.63-.83-.82-.36-.18-.8-.28-1.33-.28h-7.1v4.94Z" />
      {/* A */}
      <path d="M160.23,26.22l8-18.13h4.99l8,18.13h-4.62l-1.45-3.43h-9.08l-1.45,3.43h-4.38ZM167.44,19.46h6.33l-1.79-4.3c-.07-.19-.17-.44-.29-.75-.12-.31-.25-.64-.37-.99s-.24-.69-.36-1c-.11-.32-.2-.55-.25-.71h-.18c-.12.35-.27.75-.44,1.19s-.33.87-.49,1.28-.29.74-.4.99l-1.77,4.3Z" />
      {/* D */}
      <path d="M182.27,26.22V8.09h8.6c2.06,0,3.82.34,5.29,1.02,1.47.68,2.6,1.69,3.38,3.02.78,1.34,1.17,3.02,1.17,5.04s-.39,3.68-1.17,5.02c-.78,1.34-1.91,2.35-3.38,3.02-1.47.68-3.23,1.02-5.29,1.02h-8.6ZM186.52,22.79h4.22c.86,0,1.64-.11,2.32-.34.69-.23,1.27-.56,1.75-1,.48-.44.86-.99,1.12-1.65s.4-1.42.4-2.28v-.71c0-.86-.13-1.62-.4-2.28-.26-.66-.64-1.21-1.12-1.65s-1.07-.77-1.75-1c-.69-.23-1.46-.34-2.32-.34h-4.22v11.27Z" />
      {/* E */}
      <path d="M202.11,26.22V8.09h16.52v3.43h-12.27v3.77h10.85v3.38h-10.85v4.12h12.46v3.43h-16.71Z" />
    </svg>
  );
}
